import thunk from 'redux-thunk';
import {createLogger} from 'redux-logger';
import {applyMiddleware, compose, createStore} from 'redux';
import rootReducer from '../actions/reducers';

const loggerMiddleware = createLogger();

export const getStore = () => {
    const composeEnhancers =
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    const store = createStore(
        rootReducer,
        composeEnhancers(
            applyMiddleware(thunk, loggerMiddleware)
        )
    );


    return store;
};
